module.exports = __webpack_public_path__ + "37c415a0386f8105476a2ca4a6daf3a5.MP3";